declare namespace $ {

	type $mol_text__text_shm_hitalama_map_widget_float_entity_editor_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_textarea__title_shm_hitalama_map_widget_float_entity_editor_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_textarea['title'] >
	>
	type $mol_textarea__hint_shm_hitalama_map_widget_float_entity_editor_3 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_textarea['hint'] >
	>
	type $mol_textarea__sidebar_showed_shm_hitalama_map_widget_float_entity_editor_4 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_textarea['sidebar_showed'] >
	>
	type $mol_textarea__value_shm_hitalama_map_widget_float_entity_editor_5 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_entity_editor['fields_text'] >
		,
		ReturnType< $mol_textarea['value'] >
	>
	export class $shm_hitalama_map_widget_float_entity_editor extends $shm_hitalama_map_widget_float {
		Help( ): $mol_text
		fields_text( next?: string ): string
		Fields( ): $mol_textarea
		controls( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=editor.view.tree.d.ts.map